import { request } from "utils";

const url = "request/task-list";

export async function callGetTaskList(params) {
  const res = await request.get(url, {
    ...(params || {}),
  });
  return res;
}

// Backend currently returns an array, so we adapt it to PaginatedTable shape.
export async function callGetPaginatedTaskList(params = {}) {
  const { page = 1, per_page = 20, ...rest } = params || {};

  const rawItems = (await callGetTaskList(rest)) || [];
  const safeItems = Array.isArray(rawItems) ? rawItems : [];

  const currentPage = Math.max(parseInt(page, 10) || 1, 1);
  const perPage = Math.max(parseInt(per_page, 10) || 20, 1);

  const total = safeItems.length;
  const offset = (currentPage - 1) * perPage;
  const items = safeItems.slice(offset, offset + perPage);

  return {
    items,
    meta: {
      total,
      count: items.length,
      per_page: perPage,
      current_page: currentPage,
      total_pages: Math.ceil(total / perPage) || 1,
    },
  };
}

export default callGetTaskList;
